module.exports = __webpack_public_path__ + "static/screenshot4-59c48b0c2128ff95d699a3e81e6733f3.png";